import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appNumberFormatter]'
})
export class NumberFormatterDirective {

  
  private regex: RegExp = new RegExp(/^\d+$/);
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight'];

  constructor(private el: ElementRef) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    // Allow special keys
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }

    // Prevent non-numeric characters
    let current: string = this.el.nativeElement.value;
    if (event.key && !String(event.key).match(this.regex)) {
      event.preventDefault();
    }
    
  }

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    let input = event.target;// this.el.nativeElement;

    //@ts-ignore
    let value = input.value.replace(/\s+/g, ''); // Remove existing spaces
    
    // if (!isNaN(value) && value.length > 0) {
    //       //@ts-ignore 
    //   input.value = value.replace(/\B(?=(\d{3})+(?!\d))/g, ' '); // Add spaces every three digits
    // }
  }


}
